import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OnlineService } from '@qtek/shared/services';
import { Observable } from 'rxjs';

import { QtHttpInterceptor } from '../qtek-interceptor';

@Injectable()
export class OnlineInterceptor implements QtHttpInterceptor {
  private online = inject(OnlineService);

  readonly qtek = true;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // if (!this.online.isOnline()) {
    //   this.notifyUserAboutOfflineState();

    //   return EMPTY;
    // }

    return next.handle(req);
  }

  notifyUserAboutOfflineState() {
    console.log('detected offline');
  }
}
